// removed by extract-text-webpack-plugin
module.exports = {"Therapy":"_28kcouUG","Title":"Fz3r2YVu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/therapy/therapy-component.styles.scss
// module id = 285
// module chunks = 0